export default __webpack_public_path__ + "static/noel-e9f6750f7673395725431f62700b9594.png";